import type { MarkerIconName } from "components/map/markers";
import { DESTINATION_TYPE_TABLE, EXPLORE_TYPE_TO_DESTINATION_TYPE } from "components/map/markerVisualTokens";

export const VIBES = [
	{
		name: "Adventure",
		key: "adventure",
		color: "#e67e22",
		icon: "adventure",
	},
	{
		name: "Arts & Culture",
		key: "arts",
		color: "#9b59b6",
		icon: "arts",
	},
	{
		name: "Beach",
		key: "beach",
		color: "#3498db",
		icon: "beach",
	},
	{
		name: "Culinary",
		key: "culinary",
		color: "#e74c3c",
		icon: "culinary",
	},
	{
		name: "Festival",
		key: "festival",
		color: "#f39c12",
		icon: "festival",
	},
	{
		name: "Historic",
		key: "historic",
		color: "#8b6914",
		icon: "historic",
	},
	{
		name: "Nature",
		key: "nature",
		color: "#27ae60",
		icon: "nature",
	},
	{
		name: "Nightlife",
		key: "nightlife",
		color: "#5b4fcf",
		icon: "nightlife",
	},
	{
		name: "Off beaten path",
		key: "off_the_beaten_path",
		color: "#4a9bb5",
		icon: "off_the_beaten_path",
	},
	{
		name: "Romantic",
		key: "romantic",
		color: "#e85d8a",
		icon: "romantic",
	},
	{
		name: "Scenic",
		key: "scenic",
		color: "#7f8c8d",
		icon: "scenic",
	},
	{
		name: "Ski",
		key: "ski",
		color: "#3498db",
		icon: "ski",
	},
	{
		name: "Spiritual",
		key: "spiritual",
		color: "#8e44ad",
		icon: "spiritual",
	},
	{
		name: "Village",
		key: "village",
		color: "#a0724a",
		icon: "village",
	},
	{
		name: "Wellness",
		key: "wellness",
		color: "#27ae60",
		icon: "wellness",
	},
	{
		name: "Wildlife",
		key: "wildlife",
		color: "#2d8a4e",
		icon: "wildlife",
	},
];

export const VIBES_MAP = Object.fromEntries(VIBES.map(({ key, ...rest }) => [key, rest]));

// 2026-09: replaces the old DESTINATION_TYPE_ICON (its own hand-listed "city"/"nationalPark"/...
// names into the general 640-icon set) so every place a destination type gets an icon — the map
// marker AND this small eyebrow/badge glyph — draws from the same chunky marker set
// (markerVisualTokens.ts), not two independently-maintained icon choices per type.
export const destinationTypeIcon = (type?: string | null): MarkerIconName => {
	const destinationType = type ? EXPLORE_TYPE_TO_DESTINATION_TYPE[type] : undefined;
	return DESTINATION_TYPE_TABLE[destinationType ?? "city"].icon;
};

